// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasCategoryContext, withCategory } from "@insite/client-framework/Components/CategoryContext";
import { createWidgetElement } from "@insite/client-framework/Components/ContentItemStore";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { CustomAppState } from "@pace/App/Store/Reducers";
import parse from "html-react-parser";
import * as React from "react";
import { connect } from "react-redux";

// <XNG-Changes>
const mapStateToProps = (state: ApplicationState) => {
    const isLoading = state.pages.productList.isLoading;
    const isPLP = getCurrentPage(state).type === "ProductListPage";

    return {
        isPLPLoading: isPLP && isLoading,
        isSmallMobileScreen: (state as CustomAppState).xCommon.isSmallMobileScreen,
    };
};
// </XNG-Changes>

interface Props extends WidgetProps, HasCategoryContext, ReturnType<typeof mapStateToProps> {}

export interface CategoryDetailBannerStyles {
    container?: InjectableCss;
}

export const bannerStyles: CategoryDetailBannerStyles = {};

const styles = bannerStyles;

const CategoryDetailBanner = ({ category, isPLPLoading, isSmallMobileScreen }: Props) => {
    if (!category || !category.htmlContent || isPLPLoading) {
        return null;
    }
    // XNG-Changes: PAC-1000
    const bannerImage = isSmallMobileScreen ? category.smallImagePath : category.largeImagePath;
    return (
        <StyledWrapper
            {...styles.container}
            data-test-selector="categoryDetailBanner_htmlContent"
            {...{ hasImage: bannerImage }}
        >
            {/* XNG-Changes: update content */}
            {/* {parse(category.htmlContent, parserOptions)} */}
            {createWidgetElement("Basic/ImageTextTile", {
                fields: {
                    tileText: parse(category.htmlContent, parserOptions),
                    image: bannerImage,
                    imageAlt: category.imageAltText || (category.shortDescription ?? category.name),
                },
            })}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withCategory(CategoryDetailBanner)),
    definition: {
        group: "Category Details",
        icon: "image-landscape",
        allowedContexts: ["CategoryDetailsPage", "ProductListPage"],
    },
};

export default widgetModule;
